// Allowed list of platform options accessible at runtime, with derived type for buildtime checks

export const supportedTools = [
  'CarbonBlack Cloud - LiveQuery',
  'CarbonBlack Cloud - Investigate',
  'CarbonBlack Response',
  'Corelight Investigator',
  'CrowdStrike',
  'CrowdStrike LogScale',
  'Elastic Signal',
  'Elastic',
  'Google SecOps',
  'Microsoft Defender',
  'Microsoft Sentinel',
  'Palo Alto Cortex XDR',
  'QRadar Query',
  'SentinelOne',
  'SentinelOne - PowerQuery',
  'SentinelOne Singularity',
  'Snort',
  'Splunk',
  'Trend Micro Vision One',
  'Tanium',
  'Tanium Signal',
  'Yara',
] as const
export type SupportedTools = (typeof supportedTools)[number]

export class MatchboiError extends Error {}

/**
 * Thrown when untrusted text would reach Eta as template markup —
 * either a predicate value containing template delimiters, or a generated
 * tuning query carrying a tag that is not a field lookup. Callers at an HTTP
 * boundary should translate this to a 400.
 */
export class UnsafeTemplateError extends MatchboiError {}

export interface CustomerDataParsed {
  index: string
  sourcetype?: string
  fields: Array<string>
}

export type CustomerMapParsed = Array<CustomerDataParsed>

export interface EnvironmentTool {
  id: string
  created: Date
  lastModified: Date
  name: string
  product: SupportedTools
  rootUrl: string
  environment: Environment
  fieldMappings?: FieldMapping[]
}

export interface FieldMapping {
  name: string
  category: string
  fields?: {
    [ccmField: string]: string
  }[]
  toolSpecific?: {
    [ccmField: string]: string
  }[]
}

export interface Environment {
  id: string
  created: Date
  lastModified: Date
  name: string
  description: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  company: any
  tools: EnvironmentTool[]
}
